import { authHeader } from "./auth-header";
// import { authComputed } from "@/state/helpers";

export const userService = {
  login,
  logout,
  getAll,
};

function login(email, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  };

  return fetch(`/users/authenticate`, requestOptions)
    .then(handleResponse)
    .then((user) => {
      if (user.token) {
        const tokenExpiration = new Date();
        tokenExpiration.setHours(tokenExpiration.getHours() + 9);
        tokenExpiration.setHours(tokenExpiration.getHours() - 6);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("tokenExpiration", tokenExpiration.toISOString());
      }
      return user;
    });
}

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("user");
  localStorage.removeItem("tokenExpiration");
}

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        location.reload(true);
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    // Verificar la validez del token aquí
    if (data && data.token && data.tokenExpiration) {
      const tokenExpiration = new Date(data.tokenExpiration);
      const horaActual = new Date();
      if (horaActual < tokenExpiration) {
        // El token es válido, actualizar la fecha de expiración en el almacenamiento local
        localStorage.setItem("user", JSON.stringify(data));
        localStorage.setItem("tokenExpiration", tokenExpiration.toISOString());
      } else {
        // El token ha expirado, cerrar sesión
        logout();
        location.reload(true);
      }
    }
    return data;
  });
}
